import {AfterContentChecked, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';
import {ActivatedRoute, Router} from '@angular/router';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { EncrDecrService } from '@app/shared/services/encr-decr-service.service';
import { CryptoKeyValue } from '@app/shared/constants';
import { ProductLibraryColorModel, ProductLibraryModel } from '@app/shared/models/customized-product.interface';
import { FilterModelStoreFront } from '@app/shared/models/product';
import { InksoftService } from '@app/shared/services/inksoft/inksoft.service';
import { environment } from '@env/environment';
import { MessageService } from '@app/shared/services/common/message.service';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';

@Component({
  selector: 'app-featured-products',
  templateUrl: './featured-products.component.html',
  styleUrls: ['./featured-products.component.css']
})
export class FEATUREDPRODUCTSComponent implements OnInit, AfterContentChecked  {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  @Input() storeName: string;
  viewOnly = true;
  products:  ProductLibraryModel[] = [];  
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL =  environment.productCustomImageFolder;

  constructor(private activatedRoute: ActivatedRoute, public cs: CommonService, private router: Router ,private notificationService: NotificationService,
    private EncrDecr: EncrDecrService,
    private inksoftService: InksoftService,
    private messageService: MessageService,
    private changeDetector: ChangeDetectorRef,
    private designHuddleImageService: DesignHuddleImageService) {
    this.activatedRoute.data.subscribe(data => {
      this.viewOnly = data.viewOnly != undefined ? data.viewOnly : true;
    });
  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  fn_ViewProduct(storeUrl: any, productId: any, designId: any, type: number) {
    if (storeUrl == undefined)
      storeUrl = localStorage.getItem('storeUrl');

    // this.router.navigate([storeUrl + '/product/details'], {
    //   queryParams: { pid: productId, designId: designId, type: type }
    // });
    var encryptedproductId = this.EncrDecr.set(CryptoKeyValue.Key, String(productId))
      var encrypteddesignId = this.EncrDecr.set(CryptoKeyValue.Key, String(designId))
      this.router.navigate([storeUrl + '/product/details'], {
        queryParams: { pid: encryptedproductId, designId: encrypteddesignId, type: type, IsShopifyProduct: false }
      });
  }

  fn_RemoveProduct(productId: any, designId: any) {
    let index = this.item.data.products.findIndex(d => d.DesignId === designId);
    this.item.data.products.splice(index, 1);
    let indexP = this.products.findIndex(d => d.DesignId === designId);
    this.products.splice(indexP, 1);
    this.notificationService.success("Product has been  removed sucessfully", "Sucessfull");
  }
  ngOnInit() {
    this.getProductDetails();

    this.messageService.getFPCChange().subscribe((res: any) => {
      this.getProductDetails();
    });
  }
  
  getProductDetails() {
    if(this.item.data && this.item.data.products){
      let designIds = this.item.data.products.map((ele)=> { return ele.DesignId });
      let filterModel: FilterModelStoreFront = {
        Skip: 0,
        Take: 100,
        Size: [],
        Brand: [],
        Color: [],
        StoreName: this.storeName,
        Category: '',
        searchBy: '',
        Embroidery: true,
        ScreenPrint: true,
        DesignIds: designIds
      };
      this.inksoftService.getStorePublishProductList(filterModel).subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            if (res.Data.ResponseData.length > 0) {
              res.Data.ResponseData.forEach((obj: any) => {
                  // check if item with same id exists
                  if (!this.products.find(x => x.CustomizedProductId === obj.CustomizedProductId)) {
                    
                  let defaultStyle = obj.ColorList.find(c => c.Images.some(i => i.IsDefault));
                  if (!defaultStyle)
                    defaultStyle = obj.ColorList[0];
  
                  if (defaultStyle)
                    this.fn_FetchImageToDisplay(defaultStyle, obj);
  
                    this.products.push(obj);
                  }
              });  
            }
          }
        },
        (err: any) => {
        }
      );
    }
  }

  displayColor(obj: any) {
    return {
      'background-color': obj
    };
  }
  fn_FetchImageToDisplay(style: ProductLibraryColorModel, obj: ProductLibraryModel) {
    let img = undefined;
    var imgObj = style.Images.sort(function (x, y) {
      // true values first
      return (x.IsDefault === y.IsDefault) ? 0 : x.IsDefault ? -1 : 1;
    })[0];
    if (imgObj) {
      if (imgObj.IsCustom)
        img = this.imgCustomBaseURL + imgObj.Image;
      else
        img = this.imgBaseURL + imgObj.Image;
    }
    obj['StyleId'] = style.StyleId;
    obj['Img'] = img;
    obj['ImgLoaded'] = false;
  }

  selectStyleToCustomize(style: ProductLibraryColorModel, productIndex: any) {
    var product = this.products[productIndex];
    for (var j = 0; j < product.ColorList.length; j++) {
      if (product.ColorList[j].StyleId == style.StyleId) {
        if (product.IsWarehouseProduct) {
        }
        else {
          this.fn_FetchImageToDisplay(style, product);
        }
      }
    }
  }

  getProductImage(product: any): string {
    return this.designHuddleImageService.getProductThumbnailUrl(product);
  }
}
